import request from '@/utils/request'
import store from '@/store'

// 获取当前登录用户的 adminId
function getAdminId() {
  return store.state.userInfo?.id || store.state.userInfo?.adminId || JSON.parse(localStorage.getItem('userInfo') || '{}').id
}

// 获取管理员列表
export function getAdminList(params) {
  return request({
    url: '/admin/subaccounts',
    method: 'get',
    params: {
      ...params,
      adminId: getAdminId()
    }
  })
}

// 获取所有子账号列表（用于下拉框选择）
export function getSubAccountList() {
  return request({
    url: '/admin/subaccounts',
    method: 'get',
    params: {
      adminId: getAdminId()
    }
  })
}

// 生成微信小程序码（复用后台 /qrcode/generate：scene=活动code，扫码直达小程序对应页面，返回 base64 图 data.qrcodeUrl）
// 后端 @RequestParam 接参，参数必须走 query string（axios params）而非请求体
export function generateWxaCode(params) {
  return request({
    url: '/qrcode/generate',
    method: 'post',
    params
  })
}

// 新增管理员
export function addAdmin(data) {
  return request({
    url: '/admin/subaccounts',
    method: 'post',
    data
  })
}

// 编辑管理员
export function updateAdmin(id, data) {
  return request({
    url: `/admin/subaccounts`,
    method: 'put',
    data: {
      id,
      ...data
    }
  })
}

// 删除管理员
export function deleteAdmin(id) {
  return request({
    url: `/admin/subaccounts/${id}`,
    method: 'delete'
  })
}

// 重置密码
export function resetPassword(id, data) {
  return request({
    url: `/admin/subaccounts/${id}/password`,
    method: 'put',
    data
  })
}

// 添加内定手机号码
export function addFixedPhone(data) {
  return request({
    url: '/admin/fixed-phones',
    method: 'post',
    data: {
      ...data,
      adminId: getAdminId()
    }
  })
}

// 删除内定手机号码
export function deleteFixedPhone(id) {
  return request({
    url: `/admin/fixed-phones/${id}`,
    method: 'delete'
  })
}

// 获取内定手机号码列表
export function getFixedPhoneList() {
  return request({
    url: '/admin/fixed-phones',
    method: 'get',
    params: {
      adminId: getAdminId()
    }
  })
}

// 添加内定设备码
export function addFixedDevice(data) {
  return request({
    url: '/admin/fixed-devices',
    method: 'post',
    data: {
      ...data,
      adminId: getAdminId()
    }
  })
}

// 删除内定设备码
export function deleteFixedDevice(id) {
  return request({
    url: `/admin/fixed-devices/${id}`,
    method: 'delete'
  })
}

// 获取内定设备码列表
export function getFixedDeviceList() {
  return request({
    url: '/admin/fixed-devices',
    method: 'get',
    params: {
      adminId: getAdminId()
    }
  })
}

// 添加内定用户ID（按 user 表主键内定，精确到某一条参与记录）
export function addFixedUser(data) {
  return request({
    url: '/admin/fixed-users',
    method: 'post',
    data: {
      ...data,
      adminId: getAdminId()
    }
  })
}

// 删除内定用户ID
export function deleteFixedUser(id) {
  return request({
    url: `/admin/fixed-users/${id}`,
    method: 'delete'
  })
}

// 获取内定用户ID列表
export function getFixedUserList() {
  return request({
    url: '/admin/fixed-users',
    method: 'get',
    params: {
      adminId: getAdminId()
    }
  })
}

// 清空所有内定人员（内定用户ID + 历史内定设备码一并清除，不影响禁止获奖名单）
export function clearAllFixedUsers() {
  return request({
    url: '/admin/fixed-users/clear',
    method: 'delete',
    params: {
      adminId: getAdminId()
    }
  })
}

// 开启下一轮：仅将开奖状态重置为未开奖，不删除任何数据（大屏999/自动开奖101/到点开盲盒9）
export function startNextRound(code) {
  return request({
    url: `/admin/nextRoundByCode?code=${code}`,
    method: 'post',
    data: {}
  })
}

// 添加禁止获奖设备码（大屏999/到点101专用；已内定的设备码会被后端拒绝并提示先取消内定）
export function addBannedDevice(data) {
  return request({
    url: '/admin/banned-devices',
    method: 'post',
    data: {
      ...data,
      adminId: getAdminId()
    }
  })
}

// 取消禁止获奖（按记录id移出名单）
export function deleteBannedDevice(id) {
  return request({
    url: `/admin/banned-devices/${id}`,
    method: 'delete'
  })
}

// 获取禁止获奖设备码列表
export function getBannedDeviceList() {
  return request({
    url: '/admin/banned-devices',
    method: 'get',
    params: {
      adminId: getAdminId()
    }
  })
}

// 添加内定人员（姓名/微信昵称，type：1-姓名 2-微信昵称）
export function addFixedPerson(data) {
  return request({
    url: '/admin/fixed-persons',
    method: 'post',
    data: {
      ...data,
      adminId: getAdminId()
    }
  })
}

// 删除内定人员（姓名/微信昵称）
export function deleteFixedPerson(id) {
  return request({
    url: `/admin/fixed-persons/${id}`,
    method: 'delete'
  })
}

// 获取内定人员列表（按类型：1-姓名 2-微信昵称）
export function getFixedPersonList(type) {
  return request({
    url: '/admin/fixed-persons',
    method: 'get',
    params: {
      adminId: getAdminId(),
      type
    }
  })
}

// 获取举报列表
export function getReportList(params) {
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
  console.log( JSON.parse(localStorage.getItem('userInfo') ))
  const isMainAccount = userInfo.isadmin === 1
  return request({
    url: '/report/list',
    method: 'get',
    params: {
      adminId: getAdminId(),
      isMainAccount: isMainAccount,
      ...params
    }
  })
}

// 获取积分商城用户列表
export function getMallUserListApi(params) {
  return request({
    url: '/mall/user/list',
    method: 'get',
    params: {
      ...params,
      adminId: getAdminId()
    }
  })
}

// 获取管理员兑换记录列表
export function getAdminExchangeListApi(params) {
  return request({
    url: '/mall/exchange/admin/list',
    method: 'get',
    params: {
      ...params,
      adminId: getAdminId()
    }
  })
}

// 核销兑换记录
export function verifyExchangeApi(id) {
  return request({
    url: `/mall/exchange/verify/${id}`,
    method: 'post'
  })
}

// 清除活动数据
export function resetActivityByCode(code) {
  return request({
    url: '/admin/resetActivityByCode?code=' + code,
    method: 'post',
    data: {  }
  })
}

// 部分重置活动数据 (scope: records | users | stock | codes)
export function resetActivityScoped(code, scope) {
  return request({
    url: `/admin/resetActivityByCodeScoped?code=${code}&scope=${scope}`,
    method: 'post',
    data: {}
  })
}

// 锁定/解锁子账号
export function lockAdmin(adminId, isLocked) {
  return request({
    url: '/admin/lock',
    method: 'put',
    params: { adminId, isLocked }
  })
}

// 查询子账号锁定状态
export function getAdminLockStatus(adminId) {
  return request({
    url: '/admin/lock',
    method: 'get',
    params: { adminId }
  })
}
